import Vue from 'vue'
import iView from 'view-design'
import Router from 'vue-router'
import { staticRoutes, staticMenuList, staticTree } from './static-routes'
import store from '../store/store'
import initAsyncRouter from './async-router'
// 自定义表单
import initBiyiFormRouter from './form-router'

// Uncaught (in promise) NavigationDuplicated解决方法
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const routerConfig = {
  routes: [
    ...staticRoutes
  ]
}

const createRouter = () => new Router(routerConfig)
const router = createRouter()

export default router

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  // 单点登录
  var url = window.location.href;
  url = url.replace("%20"," ");
  var index = url.indexOf('token');
  var token = '';
  if (index >= 0) {
    token = url.substring(url.indexOf('=') + 1);
    localStorage.setItem('token', token);
  }
  getTargetComponent(to.matched[0]).then(target => {
    navigate(target, to, next)
  }).catch(err => {
    console.log(new Error('function getTargetComponent error!'))
    console.log(err)
  })
})

router.afterEach(() => {
  iView.LoadingBar.finish()
})

function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

function getTargetComponent (argu) {
  return new Promise((resolve, reject) => {
    try {
      if (!argu) {
        resolve(null)
      }
      if (typeof argu.components.default === 'function') {
        argu.components.default().then(res => {
          resolve(res.default.name)
        }).catch(error => {
          reject(error)
        })
      } else {
        resolve(argu.components.default.name)
      }
    } catch (error) {
      reject(error)
    }
  })
}

function navigate (target, to, next) {
  if ((target === 'Main' || target === null) && !store.state.app.asyncRoutesCompleted) {
    // 初始化静态菜单
    store.commit('app/setMenuList', staticMenuList || [])
    // 保存静态路由数据原始的关系树
    store.commit('app/setRoutesTree', staticTree || [])
    // 重新获取异步菜单和权限数据
    initAsyncRouter().then(menus => {
      next(router.resolve(to).route.fullPath)
    }).catch(() => {
      next('/login')
    })
  } else {
    if (to.matched.length > 0) {
      if (to.path === '/login') {
        resetRouter()
      }
      next()
    } else {
      next('/404')
    }
  }
}
